/**
 * Shared matching for the global search and the list filters, so both find
 * the same things: case and accents don't matter ("zahler" finds "Zähler"),
 * a leading "!" doesn't either ("!airhorn" finds "!sound airhorn"), and every
 * word of the query has to appear somewhere, in any order.
 */
export function normalizeSearch(s) {
    return s
        .toLowerCase()
        .replace(/ß/g, "ss")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/!/g, "")
        .trim();
}
export function searchTokens(query) {
    return normalizeSearch(query).split(/\s+/).filter(Boolean);
}
export function matchesSearch(query, fields) {
    const tokens = searchTokens(query);
    if (tokens.length === 0)
        return true;
    const hay = normalizeSearch(fields.filter(Boolean).join(" "));
    return tokens.every((t) => hay.includes(t));
}
/** Higher = better. 0 = no match. A hit in the title beats one in the details. */
export function scoreSearch(query, title, rest = []) {
    const tokens = searchTokens(query);
    if (tokens.length === 0)
        return 1;
    if (!matchesSearch(query, [title, ...rest]))
        return 0;
    const t = normalizeSearch(title);
    const q = tokens.join(" ");
    if (t === q)
        return 100;
    if (t.startsWith(q))
        return 80;
    if (t.split(/\s+/).some((w) => w.startsWith(tokens[0])))
        return 60;
    if (tokens.every((tok) => t.includes(tok)))
        return 40;
    return 10;
}
